import { CSSProperties, useCallback, useState } from "react";
import {
  TimeUpdateCallback,
  useTimeUpdateEvent,
} from "../../hooks/useTimeUpdateEvent";
import { videoTimeToString } from "../../utils/time";
import { useControlBar } from "../../contexts/ControlBar";
import { useRoot } from "../../contexts/Root";
import { useRange } from "../../contexts/Range";

type VideoTime = {
  currentTime: number;
  duration: number;
};

export const TimeDisplay = () => {
  const { isActive } = useControlBar();
  const [time, setTime] = useState<VideoTime>({ currentTime: 0, duration: 0 });
  const { currentTimeOffset, adjustedDuration } = useRange();
  const {
    theme: { foreground },
  } = useRoot();

  const handler: TimeUpdateCallback = useCallback(
    (data) => {
      setTime({
        currentTime: data.currentTime - currentTimeOffset,
        duration: adjustedDuration,
      });
    },
    [adjustedDuration, currentTimeOffset]
  );

  useTimeUpdateEvent(isActive, handler);

  const style = {
    color: foreground,
    display: "flex",
    flexDirection: "row",
    gap: 5,
  } as CSSProperties;

  const { duration, currentTime } = videoTimeToString(time);

  return (
    <div style={style}>
      <span>{currentTime}</span>/<span>{duration}</span>
    </div>
  );
};
